// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sources/less/app.less
// module id = 2
// module chunks = 0